/**
 * 功能开关路由守卫
 * ---------------------------------------------------------------------------
 * **关掉的功能要真的进不去，不能只把菜单标灰。**
 *
 * 之前只有侧栏显示"未开启"，页面照常打开、照常能建预约——那个开关就是个
 * 视觉提示，不是开关。门店关了之后以为不用了，前台照样在里面约人，
 * 到期数据还在跑。
 *
 * 拦下来之后**跳到能开开关的地方**而不是给一个死胡同页面：门店点进来就是想用，
 * 直接把他送到能打开开关的地方，比让他自己找要少一步。
 */
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingBlock } from '@/components/ui/empty-state';
import { useEnabledFeatures } from '@/lib/use-enabled-features';

export function RequireFeature({
  feature,
  children,
}: {
  feature: string;
  children: React.ReactNode;
}) {
  const { features, loading } = useEnabledFeatures();
  const location = useLocation();

  /*
    **加载中不能当成"已关闭"。** 那样每次刷新页面都会先被踢走再跳回来，
    看起来像是随机弹出去。
  */
  if (loading) return <LoadingBlock label="正在打开" />;

  if (!features.has(feature)) {
    return (
      /*
        **跳门店设置，不是订阅与账单**（能力开关 2026-08-13 搬过去了）。
        被拦下来最常见的原因就是开关没开，落在开关旁边才点得到；
        属于"套餐不含"的那种，门店设置上的提示会再给一条去订阅与账单看版本的路。
      */
      <Navigate
        to="/settings"
        replace
        // 带上从哪来的，门店设置据此说明为什么跳过来
        state={{ blockedFeature: feature, from: location.pathname }}
      />
    );
  }

  return <>{children}</>;
}
